import { Component, OnInit } from '@angular/core';
import { Stream } from 'src/models/stream';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayerService } from 'src/app/services/player.service';
import { UserService } from 'src/app/services/user.service';
import { combineLatest } from 'rxjs';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-radio-detail',
  templateUrl: './radio-detail.component.html',
  styleUrls: ['./radio-detail.component.scss']
})
export class RadioDetailComponent implements OnInit {

  public stream: Stream;

  //public isFavorite = false;

  public currentPlayingId;

  private autoPlay: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private streamService: StreamService,
    private playerService: PlayerService,
    private userService: UserService) {
      //this.autoPlay = this.router.getCurrentNavigation().previousNavigation !== null // autoplay only if not new window
      //                  && (this.router.getCurrentNavigation().extras.state === undefined || this.router.getCurrentNavigation().extras.state.autoplay !== false);
    }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const streamName = params['name'];

      this.streamService.getStationDetails(streamName).subscribe((stream: Stream) =>  {
        this.stream = stream;

        this.playerService.setCurrentStream(stream);

        /*if (this.autoPlay && this.podcast.episodes !== undefined && this.podcast.episodes.length > 0) {
          this.onPlayEpisodeClicked(this.podcast.episodes[0]);
        }*/
      });

      /*this.podcastService.getRecommendedPodcasts(this.podcastId).subscribe((podcasts: Array<Podcast>) => {
        this.recommendations = podcasts;
      });*/
    });

    /*this.userService.getFavorites().subscribe((streams: Stream[]) => {
      const streamFound = streams.find((fav: Stream) => fav.id.toString() === this.podcast.id);

      this.isFavorite = streamFound !== undefined;
    });*/

    combineLatest(this.playerService.currentStream, this.playerService.isPlaying).subscribe(([stream, isPlaying]) => {
      this.currentPlayingId = isPlaying ? stream.id.toString() : undefined;
    });
  }

  /*public loadOlderPodcasts() {
    this.podcastService.getPodcast(this.podcastId, this.podcast.nextEpisodePubDate).subscribe((podcast: Podcast) =>  {
      this.podcast.episodes = this.podcast.episodes.concat(podcast.episodes);

      this.podcast.nextEpisodePubDate = podcast.nextEpisodePubDate;
    });
  }*/

}
